import React from "react";

import { OverflowTooltip } from "components";
import { getFullName } from "helpers";
import { Application, TableCellProp } from "types";

const pendedToColumn = () => ({
	Header: "Pended To",
	accessor: "PendTo",
	disableSortBy: true,
	Cell: ({ row: { original } }: TableCellProp<Application>) => {
		const assignedTo = original?.pend_assignee
			? getFullName(original?.pend_assignee)
			: "Unassigned";

		return (
			<OverflowTooltip onlyOnLaptop title={assignedTo}>
				{assignedTo}
			</OverflowTooltip>
		);
	},
});

export default pendedToColumn;
